import React, { useMemo } from 'react';
import { Schedule } from 'store/schedules/interfaces';
import { SchedulePreviewCalendarContext } from './SchedulePreviewCalendar.context';
import { PreviewScheduleRange } from '../convertScheduleRanges';

export interface SchedulePreviewCalendarContextProps {
  scheduleRanges: PreviewScheduleRange[];
  schedule: Schedule;
  children: React.ReactNode;
}

export default function SchedulePreviewCalendarProvider({
  scheduleRanges,
  children,
  schedule,
}: SchedulePreviewCalendarContextProps) {
  const contextValue = useMemo(
    () => ({ scheduleRanges, schedule }),
    [scheduleRanges, schedule],
  );

  return (
    <SchedulePreviewCalendarContext.Provider value={contextValue}>
      {children}
    </SchedulePreviewCalendarContext.Provider>
  );
}
